import NoAccessImg from "../../assets/no-access.png";
const NoAccess = () => {
  return (
    <div className="bg-secondary h-screen flex items-center justify-center flex-col">
      <img src={NoAccessImg} alt="No Access" />
      <h3 className="primaryText mt-3 mb-1 font-normal">No Access!</h3>
      <h4 className="text-secondaryText font-normal">
        Sorry, you don’t have access to this page. Please contact your admin
      </h4>
    </div>
  );
};

export default NoAccess;
